var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('div',{staticClass:"main-container"},[_c('first-block'),_c('second-block'),(_vm.lang === 'zh')?_c('third-block'):_vm._e(),(_vm.lang === 'zh')?_c('fourth-block'):_vm._e(),_c('fifth-block'),_c('sixth-block')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }